'use strict';

module.exports = function forPage(page, chunk) {
  var collection = this.items.slice(page * chunk - chunk, page * chunk);

  return new this.constructor(collection);
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/forPage.js
// module id = 1229
// module chunks = 2